import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';

register('blog-section', [slider]);

const selectors = {
  input: '[data-search-recipes-input]',
  searchBox: '[data-search-box]',
  imagePlaceholder: '[data-image-placeholder]',
  menuItems: '[data-tag-id]',
  subMenuItems: '[data-tag-menu]'
};

const classes = {
  resultsBox: 'results-box',
};

class RecipesListMenu extends HTMLElement {
  constructor() {
    super();

    this.menuItems = document.querySelectorAll(selectors.menuItems);
    this.subMenuItems = document.querySelectorAll(selectors.subMenuItems);
    this.activeMenuItem = document.querySelector('.tag-active-data');
  }

  connectedCallback() {
    this.menuItems.forEach(menuItem => {

      menuItem.addEventListener('click', (even) => {
        console.log('menuItem', menuItem);


        const subMenuName = menuItem.dataset.tagId;

        console.log('subMenuName', subMenuName);

        if (menuItem.getAttribute('aria-expanded') === 'true') {
          console.log(1);

          menuItem.setAttribute('aria-expanded', 'false');

          this.querySelector(`[data-tag-menu=${subMenuName}]`).setAttribute('aria-hidden', 'true')

        } else {
          console.log(2);

          this.querySelectorAll(`[data-tag-id]:not([data-tag-id*=${subMenuName}])`).forEach(item => item.setAttribute('aria-expanded', 'false'));

          menuItem.setAttribute('aria-expanded', 'true');

          this.querySelector(`[data-tag-menu=${subMenuName}]`).setAttribute('aria-hidden', 'false');

          this.querySelectorAll(`[data-tag-menu]:not([data-tag-menu*=${subMenuName}])`).forEach(item => item.setAttribute('aria-hidden', 'true'));
        }
      });
    });
  }
}

class customRecipesSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.searchForm = this.querySelector(selectors.input);
    this.searchBox = this.searchForm.closest(selectors.searchBox);
    this.searchTimeoutThrottle = 500;
    this.searchTimeout = -1;
    this.emptyBoxMessage = 'No results';
    this.seeAllMessage = 'See all recipes result';
    this.defaultImage = this.querySelector(selectors.imagePlaceholder).innerHTML;
    this.resultsBox = document.createElement('div');
    this.resultsBox.classList.add(classes.resultsBox);
    this.resultsBox.setAttribute('aria-hidden', 'true');
    this.searchBox.appendChild(this.resultsBox);

    this.customRecipesSearch();
  }

  customRecipesSearch () {
    this.clickEvent = () => this.handleBodyClick(event);

    this.searchForm.addEventListener('focusin', (e)=> {
      this.resultsBox.setAttribute('aria-hidden', 'false');

      document.addEventListener('click', this.clickEvent);
      document.addEventListener('focusout', this.clickEvent);
    });

    this.searchForm.addEventListener('keyup', (event)=> {
      const term = event.target.value;

      if (term.length > 2) {
        clearTimeout(this.searchTimeout);

        // const form = this.closest('form');
        const searchURL = `${theme.routes.predictive_search_url}.json?q=${encodeURIComponent(term)}&resources[type]=article&resources[limit]=10&resources[options][fields]=title`
        const form = this.querySelector('form');
        const linkURL = form.getAttribute('action') + '?type=article&q=' + term;


        this.searchTimeout = setTimeout(()=> {
          fetch(searchURL)
            .then(response => response.json())
            .then(data => {
              console.log('data.resources.results', data.resources.results);

              const articlesSuggestions = data.resources.results.articles;
              this.resultsBox.innerHTML = '';

              console.log(articlesSuggestions, 'articlesSuggestions');

              if (articlesSuggestions.length > 0) {
                articlesSuggestions.forEach((item)=> {
                  const row = document.createElement('a');
                  row.className = 'recipe-item';
                  row.href = item.url;

                  if (item.featured_image.url) {
                    const img = document.createElement('div');
                    img.className = 'recipe-img';
                    img.innerHTML = '<img alt="' + item.title + '" src="' + item.featured_image.url + '" />';
                    row.appendChild(img);
                  } else {
                    const img = document.createElement('div');
                    img.className = 'recipe-img';
                    img.innerHTML = this.defaultImage;
                    row.appendChild(img);
                  }

                  const title = document.createElement('div');
                  title.className = 'recipe-title';
                  title.textContent = item.title;
                  row.appendChild(title);

                  this.resultsBox.appendChild(row);
                });

                const searchAllResults = document.createElement('div');
                searchAllResults.className = 'search-all-results';
                searchAllResults.innerHTML = '<a href="' + linkURL + '" class="note">' + this.seeAllMessage + '</a>';
                this.resultsBox.appendChild(searchAllResults);
              } else {
                this.resultsBox.innerHTML = '<div class="recipe-item">' + this.emptyBoxMessage + '</div>';
              }
            });
        }, this.searchTimeoutThrottle);

      } else if (term.length <= 2) {
        this.resultsBox.innerHTML = '';
      }
    });

    this.searchForm.setAttribute('autocomplete', 'off');
  }

  handleBodyClick(event) {
    const target = event.target;

    console.log('handleBodyClick');

    if (!this.contains(target)) {
        this.resultsBox.setAttribute('aria-hidden', 'true');

      document.removeEventListener('click', this.clickEvent);
      document.removeEventListener('focusout', this.clickEvent);
    }
  }
}

if (!customElements.get('recipes-list-menu')) {
  customElements.define('recipes-list-menu', RecipesListMenu);
}

if (!customElements.get('custom-recipes-search')) {
  customElements.define('custom-recipes-search', customRecipesSearch);
}